export const HOME_ROUTE = "/workspaces/:workspaceId";
export const BASE_ROUTE = "/";
export const JOB_DASHBOARD_ROUTE = "/jobdash";
export const LOGIN_ROUTE = "/login";
export const SIGN_UP_ROUTE = "/sign-up";
export const USER_INFO = "/user-info";
export const ACCOUNT_SETTINGS_ROUTE = HOME_ROUTE + "/settings";
export const ALL_WORKSPACES_ROUTE = HOME_ROUTE + "/manage-workspaces";
export const WORKSPACE_SETTINGS_ROUTE =
  ALL_WORKSPACES_ROUTE + "/:targetWorkspaceId/settings";
export const RESET_PASSWORD_ROUTE = "/reset-password";
export const FORGOT_PASSWORD_ROUTE = "/forgot-password";
export const VERIFY_EMAIL_ROUTE = "/verify-email";
export const REGISTRATION_COMPLETE_ROUTE = "/registration-complete";
export const ACCESS_DENIED_ROUTE = "/denied";
export const ABSTRACT_SUMMARY_ROUTE =
  HOME_ROUTE + "/abstract-summary/:abstractRequestId";
export const ACCOUNT_DELETED_ROUTE = "/account-deleted";
export const TERMS_GLOSSARY_ROUTE = HOME_ROUTE + "/terms-glossary";

// Sharing
export const SHARING_HOME_ROUTE = "/sharing";
export const SHARING_ABSTRACT_ROUTE = SHARING_HOME_ROUTE + "/abstract-request";

//Workspace Invites
export const ACCEPT_WORKSPACE_INVITE_ROUTE = "/accept-invite";
